import { mxCell, MxGraphNS } from "@edp-pmf/mxgraph-ts";
import { FlowElement, DiagramElement } from "@edp-pmf/bpmn-model";

export class Cell extends mxCell {
    flowElement: FlowElement;
    diagramElement: DiagramElement & { BpmnElementId: string };

    constructor(value?: any, geometry?: MxGraphNS.mxGeometry, style?: string) {
        super(value, geometry, style);
    }

}
